import { type SalesMetricV2, type SalesMetricV2Statuses } from "./types";

export function makeDistinctAdKeyCount(): SalesMetricV2 {
  const id = "distinctAdKeyCount";
  const name = "Ad Key Count";

  return {
    id,
    name,
    fullName: name,
    description: name,
    category: "northbeam",
    positiveTrend: "up",
    format: "integer",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeBreakdownCount(breakdowns: string[]): SalesMetricV2 {
  const strigifiedBreakdowns = JSON.stringify(breakdowns);
  const id = `breakdownCount:${strigifiedBreakdowns}`;
  const name = "Breakdown Count";

  return {
    id,
    name,
    fullName: name,
    description: name,
    category: "northbeam",
    positiveTrend: "up",
    format: "integer",
    getValue(metrics) {
      return metrics.breakdownCounts?.[strigifiedBreakdowns];
    },
  };
}

export function makeStatuses(): SalesMetricV2Statuses {
  const id = "statuses";
  const name = "Status";

  return {
    id,
    name,
    fullName: name,
    description: name,
    category: "northbeam",
    positiveTrend: "up",
    format: "integer",
    getValue(metrics) {
      return metrics[id];
    },
  };
}
